import React, { useEffect, useState } from "react";
import {
  signUpAndOnboardingModalStore,
  useReviewCheckpointChallengeStore,
  useSubscriptionUpsellStore,
} from "../../zustand/globalStore";

import { useClinicalExamStationStore } from "../../zustand/clinicalExamStationStore";
import { useTutorNamePollStore } from "../../features/tutor-name-poll/tutorNamePollStore";
import { SHOULD_USE_ELITE_FIRST_UPSELL_MODAL } from "../upsell/upsellFlowConfig";

const TwoStepUpsellModalContainer = React.lazy(() =>
  import("../upsell/TwoStepUpsellModalContainer").then((module) => ({ default: module.TwoStepUpsellModalContainer }))
);
const EliteFirstUpsellModalContainer = React.lazy(() =>
  import("../upsell/EliteFirstUpsellModalContainer").then((module) => ({
    default: module.EliteFirstUpsellModalContainer,
  }))
);
const QuestionQualityUpsellModal = React.lazy(() =>
  import("../upsell/QuestionQualityUpsellModal").then((module) => ({ default: module.QuestionQualityUpsellModal }))
);
const ModalSignUpLoginAndOnboardingComponent = React.lazy(() => import("./ModalSignUpLoginAndOnboardingComponent"));
const MasteryChallengeModal = React.lazy(() => import("../upsell/MasteryChallengeModal"));
const ReviewCheckpointChallengePage = React.lazy(() => import("../upsell/ReviewCheckpointChallengePage"));
const TutorNamePollModalContainer = React.lazy(
  () => import("../../features/tutor-name-poll/TutorNamePollModalContainer")
);
const ClinicalExamStationOverlay = React.lazy(
  () => import("../../pages/clinical-exam-practice-page/ClinicalExamStationOverlay")
);

// After its first open, retain the owner through close animations and follow-up
// dialogs (especially the Pro→Elite success dialog, which outlives the paywall).
export function MountOnFirstOpen({ open, children }: { open: boolean; children: React.ReactNode }) {
  const [hasOpened, setHasOpened] = useState(open);
  useEffect(() => {
    if (open) setHasOpened(true);
  }, [open]);
  return open || hasOpened ? <React.Suspense fallback={null}>{children}</React.Suspense> : null;
}

export default function DeferredGlobalModals() {
  const upsellOpen = useSubscriptionUpsellStore((state) => state.shouldShowSubscriptionUpsellModal);
  const qualityUpsellOpen = useSubscriptionUpsellStore((state) => state.isQuestionQualityUpsellModalOpen);
  const masteryOpen = useSubscriptionUpsellStore((state) => state.masteryChallenge != null);
  const checkpointOpen = useReviewCheckpointChallengeStore((state) => state.reviewCheckpointChallenge != null);
  const signUpOpen = signUpAndOnboardingModalStore((state) => state.shouldShowModalSignUpAndLogin);
  const clinicalExamStationOpen = useClinicalExamStationStore((state) => state.openStation != null);
  const tutorNamePollOpen = useTutorNamePollStore((state) => state.callContext != null);

  return (
    <>
      <MountOnFirstOpen open={upsellOpen}>
        {SHOULD_USE_ELITE_FIRST_UPSELL_MODAL ? <EliteFirstUpsellModalContainer /> : <TwoStepUpsellModalContainer />}
      </MountOnFirstOpen>
      <MountOnFirstOpen open={qualityUpsellOpen}><QuestionQualityUpsellModal /></MountOnFirstOpen>
      <MountOnFirstOpen open={masteryOpen}><MasteryChallengeModal /></MountOnFirstOpen>
      <MountOnFirstOpen open={checkpointOpen}><ReviewCheckpointChallengePage /></MountOnFirstOpen>
      <MountOnFirstOpen open={clinicalExamStationOpen}><ClinicalExamStationOverlay /></MountOnFirstOpen>
      <MountOnFirstOpen open={tutorNamePollOpen}><TutorNamePollModalContainer /></MountOnFirstOpen>
      <MountOnFirstOpen open={signUpOpen}><ModalSignUpLoginAndOnboardingComponent /></MountOnFirstOpen>
    </>
  );
}
